const loadScriptByURL = (id, url, callback) => {
  const isScriptExist = document.getElementById(id);

  if (!isScriptExist) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = id;
    script.onload = function () {
      if (callback) callback();
    };
    document.body.appendChild(script);
  }

  if (isScriptExist && callback) callback();
};

const hidebadgeGGRecaptcha = () => {
  const el = document.querySelector('.grecaptcha-badge');
  el.style.display = 'none';
};

export { loadScriptByURL, hidebadgeGGRecaptcha };